/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Frostfreemodestate3Inputs */



/**
* | output |
* | --- |
* | "Frost-free mode state" |
*
* @param {Ahu_History_Key_Frostfreemodestate3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_frostfreemodestate3 = /** @type {((inputs?: Ahu_History_Key_Frostfreemodestate3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Frostfreemodestate3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Frost-free mode state")
	return /** @type {LocalizedString} */ ("Etat du mode hors gel")
});
export { ahu_history_key_frostfreemodestate3 as "ahu_history_key_frostFreeModeState" }